import React from "react";
import { Typography } from "@mui/material";
import { pageTitleSx, pageDescSx } from "./styles";

function SettingsPageHeader({ title, description, titleSx, descriptionSx }) {
  return (
    <>
      <Typography component="h2" sx={{ ...pageTitleSx, ...titleSx }}>
        {title}
      </Typography>
      {description ? (
        <Typography component="p" sx={{ ...pageDescSx, ...descriptionSx }}>
          {description}
        </Typography>
      ) : null}
    </>
  );
}

export default SettingsPageHeader;
